import Http from '@/utils/http/index';
import { shallowClones } from '@/utils/tools/utils';

// 获取 Ethoca 预警列表
export function queryEthocaAlertList(data) {
  const params = shallowClones(data);
  if (params.outcomeList && typeof params.outcomeList === 'string') {
    params.outcomeList = params.outcomeList.split(',');
  }
  if (params.refundStatusList && typeof params.refundStatusList === 'string') {
    params.refundStatusList = params.refundStatusList.split(',');
  }
  if (params.outcomeList && params.outcomeList[0] === '') {
    delete params.outcomeList;
  } else if (params.outcomeList === '') {
    delete params.outcomeList;
  }
  if (params.refundStatusList && params.refundStatusList[0] === '') {
    delete params.refundStatusList;
  } else if (params.refundStatusList === '') {
    delete params.refundStatusList;
  }
  return Http.post('/ethoca/agency-cw/page', params);
}

// 批量处理
export function batchEthocaAlertOutcome(data) {
  return Http.post('/ethoca/agency-cw/outcomeBatch', data);
}

// 处理
export function outcomeEthocaAlert(data) {
  return Http.post('/ethoca/agency-cw/outcome', data);
}

export function queryEthocaAlertDetail(id) {
  return Http.get(`/ethoca/agency-cw/detail/${id}`);
}

export function queryEthocaEnrollmentList(data) {
  const params = shallowClones(data);
  if (params.enrollmentStatusList && typeof params.enrollmentStatusList === 'string') {
    params.enrollmentStatusList = params.enrollmentStatusList.split(',');
  }
  if (params.enrollmentStatusList && params.enrollmentStatusList[0] === '') {
    delete params.enrollmentStatusList;
  } else if (params.enrollmentStatusList === '') {
    delete params.enrollmentStatusList;
  }
  return Http.post('/ethoca/agency-cw/enrollment/page', params);
}

export function queryEthocaEnrollmentDetail(id) {
  return Http.get(`/ethoca/agency-cw/enrollment/get/${id}`);
}

export function updateEthocaEnrollmentInfo(data) {
  return Http.post('/ethoca/agency-cw/enrollment/transition', data);
}

export function addEthocaEnrollmentInfo(data) {
  return Http.post('/ethoca/agency-cw/enrollment/save', data);
}

export function batchImportEthocaEnrollment(params) {
  return Http.post('/ethoca/agency-cw/enrollment/batchAdd', params, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

export function batchImportEthocaAlerts(params) {
  return Http.post('/ethoca/agency-cw/batchAdd', params, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

export function downloadEthocaEnrollmentList(data) {
  const params = shallowClones(data);
  if (params.enrollmentStatusList && typeof params.enrollmentStatusList === 'string') {
    params.enrollmentStatusList = params.enrollmentStatusList.split(',');
  }
  if (params.enrollmentStatusList && params.enrollmentStatusList[0] === '') {
    delete params.enrollmentStatusList;
  } else if (params.enrollmentStatusList === '') {
    delete params.enrollmentStatusList;
  }
  return Http.post('/ethoca/agency-cw/enrollment/download', params);
}

export function downloadEthocaAlertsList(data) {
  const params = shallowClones(data);
  if (params.outcomeList && typeof params.outcomeList === 'string') {
    params.outcomeList = params.outcomeList.split(',');
  }
  if (params.refundStatusList && typeof params.refundStatusList === 'string') {
    params.refundStatusList = params.refundStatusList.split(',');
  }
  if (params.outcomeList && params.outcomeList[0] === '') {
    delete params.outcomeList;
  } else if (params.outcomeList === '') {
    delete params.outcomeList;
  }
  if (params.refundStatusList && params.refundStatusList[0] === '') {
    delete params.refundStatusList;
  } else if (params.refundStatusList === '') {
    delete params.refundStatusList;
  }
  return Http.post('/ethoca/agency-cw/download', params);
}
